export default function buildGetListingTagData({
    apiEndpoint,
    apiTools
}) {
    return async function getListingTagData(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }` 
        })
       
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'salaTokken'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}